<template>
  <div class="assignment-details-block">
    <div v-if="assignment.type !== CONSOLIDATE" class="pt-1 pb-1">
      <div>
        {{ isReturn ? toAddressString(assignment.senderAddress) : toAddressString(assignment.recipient) }}
      </div>

      <div v-if="assignment.item">
        <small class="text-muted mr-2">
          {{ isReturn ? (assignment.senderAddress?.companyName || '') : addressOwner(assignment.recipient) }}
        </small>
        <b-badge variant="secondary" class="mr-2"> {{ assignment.item.weight }} g. </b-badge>
        <b-badge variant="secondary">
          {{ assignment.item.length }}x{{ assignment.item.width }}x{{ assignment.item.height }}cm
        </b-badge>
      </div>

      <div>
        <small v-if="isReturn && assignment.senderAddress?.phoneNumber" class="text-muted mr-2">
          {{ assignment.senderAddress.phoneNumber }}
        </small>
        <small v-if="isReturn && assignment.senderAddress?.email" class="text-muted">
          {{ assignment.senderAddress.email }}
        </small>
        <small v-if="!isReturn && assignment.recipient?.phoneNumber" class="text-muted mr-2">
          {{ assignment.recipient.phoneNumber }}
        </small>
        <small v-if="!isReturn && assignment.recipient?.email" class="text-muted">
          {{ assignment.recipient.email }}
        </small>
      </div>
    </div>
    <div v-else>
      <b-badge variant="success"> {{ assignment.itemsCount }} addresses </b-badge>
      <div v-if="assignment.sourceFiles?.length" class="pt-1">
        <div v-for="(file, key) in assignment.sourceFiles" :key="key" class="text-muted">
          {{ fileNameTrim(file.name) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { BBadge } from 'bootstrap-vue-next'
import { computed, defineComponent, type PropType } from 'vue'
import { useAddressTransformers } from '@/composables/Address/useAddressTransformers'
import { CONSOLIDATE, RETURN } from '@/const/AssignmentTypes'
import { fileNameTrim } from '@/services/Helpers'

export default defineComponent({
  name: 'AssignmentDetailsCell',
  components: { BBadge },
  props: {
    assignment: {
      type: Object as PropType<Assignment>,
      required: true,
    },
  },
  setup(props) {
    const { addressOwner, toAddressString } = useAddressTransformers()
    const isReturn = computed(() => props.assignment.type === RETURN)

    return {
      fileNameTrim,
      toAddressString,
      addressOwner,
      isReturn,
      CONSOLIDATE,
    }
  },
})
</script>
